export default "__VITE_ASSET__DE7ij2$a__"